import React from "react";
import middleware from "./middleware/middleware";
import ManageAllPublisher from "../component/sections/publisher/manage/AllPublisher";

const sitesRoutes = [
  {
    path: "/publisher/manage/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ManageAllPublisher />,
        "ManageAllPublisher"
      );
    },
    exact: true,
  },
];

export default sitesRoutes;
